export default __webpack_public_path__ + "static/media/services_surveying_0.3e9525b9.jpg";